import FroalaEditor from "froala-editor";
import { i18n } from "@/i18n/index";
import icons from "../FroalaIcons";

Object.assign(FroalaEditor.POPUP_TEMPLATES, {
    "dynamicImagePlugin.popup": "[_TITLE_]"
});

FroalaEditor.PLUGINS.dynamicImagePlugin = function (editor) {
    let el, name, fullPath;
    const coords = {
        top: 0,
        left: 0,
        offset: 0
    };

    function setPopupPosition() {
        coords.left = el.offset().left;
        coords.top = el.offset().top - 50;
        coords.offset = 0;
    }

    function createPopupTemplate() {
        const deleteImg = i18n.t("froala.delete");
        return {
            title: `<div class="dynamic-image-popup" style="background-color: #BF4AE2"><span class="fr-btn" data-title="${fullPath}">${name}</span>
            <div style="display: inline" class="fr-btn"  data-title="${deleteImg}">
            <svg class="fr-svg fr-command" data-cmd="deleteDynamicImage" viewBox="0 0 24 24" width="24px" height="24px">${icons.delete}</svg>
            </div>
            </div>`
        };
    }

    function scrollImgMenu() {
        if (editor.popups.isVisible("dynamicImagePlugin.popup")) {
            setPopupPosition();
            editor.popups.show("dynamicImagePlugin.popup", coords.left, coords.top, coords.offset);
        }
    }

    function initPopup(fromNotif) {
        const popup = editor.popups.get("dynamicImagePlugin.popup");
        if (popup) {
            popup.remove();
        }
        const template = createPopupTemplate();
        editor.popups.create("dynamicImagePlugin.popup", template);
        editor.popups.setContainer("dynamicImagePlugin.popup", editor.$("#doc-builder"));
        const imgMenu = editor.popups.get("dynamicImagePlugin.popup");
        if (fromNotif) {
            imgMenu.attr("id", "dynamic-image-menu-notif");
        } else {
            imgMenu.attr("id", "dynamic-image-menu");
        }
        if (editor.$wp) {
            editor.$wp.off(`scroll.dynamicImagePlugin.popup.ed${editor.id}`, scrollImgMenu);
            editor.$wp.off(`scroll.dynamicImagePlugin.popup.ed${editor.sid}`, scrollImgMenu);
            editor.$wp[0]["data-events"] = [];
            editor.events.$on(editor.$wp, "scroll.dynamicImagePlugin.popup", scrollImgMenu);
        }
    }

    function showPopup(elem, fromNotif) {
        el = elem;
        name = el.attr("data-before");
        fullPath = el.attr("data-after");
        initPopup(fromNotif);
        setPopupPosition();
        el.addClass("selected");
        if (!editor.popups.isVisible("table.edit")) {
            editor.popups.show("dynamicImagePlugin.popup", coords.left, coords.top, coords.offset);
        } else {
            editor.popups.show("dynamicImagePlugin.popup", coords.left, coords.top, coords.offset);
            editor.popups.show("table.edit");
        }
        editor.popups.onHide("dynamicImagePlugin.popup", () => {
            el.removeClass("selected");
        });
    }

    function setVisible(fromNotif) {
        el.addClass("selected");
        if (fromNotif) {
            editor.$("#dynamic-image-menu-notif").addClass("fr-active");
        } else {
            editor.$("#dynamic-image-menu").addClass("fr-active");
        }
    }

    function hidePopup() {
        editor.popups.hide("dynamicImagePlugin.popup");
    }

    function deleteDynamicImage() {
        el.remove();
        hidePopup();
        editor.toolbar.enable();
    }

    return {
        showPopup,
        setVisible,
        hidePopup,
        deleteDynamicImage
    };
};
FroalaEditor.DefineIcon("dynamicImage", { template: "textSVG", PATH: icons.dynamicImage, NAME: i18n.t("froala.dynamicImage") });
FroalaEditor.DefineIcon("lineBefore", { template: "customSVG", PATH: icons.lineBefore });
FroalaEditor.DefineIcon("lineAfter", { template: "customSVG", PATH: icons.lineAfter });

FroalaEditor.RegisterCommand("deleteDynamicImage", {
    title: null,
    undo: true,
    focus: true,
    callback() {
        this.dynamicImagePlugin.deleteDynamicImage();
    },
    plugin: "dynamicImagePlugin"
});
